import AbstractBrickConfig from './abstract-brick-config';

export default class LeaderBoardBrickConfig extends AbstractBrickConfig {
  constructor(params) {
    super(params);

    // .png file
    this.imageUrl = params.imageUrl || params.image_url;

    // playstation.com
    this.imageLink = params.imageLink || params.image_link;

    this.listId = params.listId || params.list_id;
    this.providerFormatId = params.providerFormatId || params.provider_format_id;

    this.version = params.version;
    this.color = params.color;
    this.buildWithIframe = true;
  }

  errors() {
    const errorArray = super.errors();

    if (!this.imageUrl) {
      errorArray.push('imageUrl cannot be null');
    }

    if (!this.imageLink) {
      errorArray.push('imageLink cannot be null');
    }

    if (!this.listId) {
      errorArray.push('listId cannot be null');
    }

    if (!this.providerFormatId) {
      errorArray.push('providerFormatId cannot be null');
    }

    return errorArray;
  }

  toQueryParamObject() {
    const queryParams = super.toQueryParamObject();

    if (this.imageUrl) queryParams.imageUrl = this.imageUrl;
    if (this.imageLink) queryParams.imageLink = this.imageLink;
    if (this.listId) queryParams.listId = this.listId;
    if (this.providerFormatId) queryParams.providerFormatId = this.providerFormatId;
    if (this.version) queryParams.version = this.version;
    if (this.color) queryParams.color = this.color;

    return queryParams;
  }
}



// WEBPACK FOOTER //
// ./src/models/leaderboard-brick-config.js